/**
 * @file 加载组件
 * @author mengchen <mengchen@babytree-inc.com>
 */
import React, { Fragment } from 'react';
import Mask from '../Mask';
import './index.scss';

export const Loading = React.forwardRef(
  ({ loading = true, message = '', className = '', mask = true }, ref) => {
    return (
      <Fragment>
        {mask ? <Mask backgroundColor="transparent" /> : null}
        <div
          id="component-loading"
          className={`${className} ${
            loading ? 'component-loading-in' : 'component-loading-out'
          }`}
          ref={ref}
        >
          <div className="g-bbt-loading-logo component-loading-main"></div>
          {message ? (
            <p className="component-loading-message">{message}</p>
          ) : null}
        </div>
      </Fragment>
    );
  }
);


export const Waiting = () => (
  <div className="component-waiting">
    <span />
  </div>
);
